module.exports = __webpack_public_path__ + "static/media/renta-vitalicia-oficiales.3f049375.png";